<template>
  <footer style="opacity: 0;">
    <div
      class="footer__wrapper"
      v-if="!mobileFooter"
    >
      <div
        class="footer__line"
        data-anim="line"
      />

      <aside class="footer__contact">
        <transition @enter="enter" @leave="leave" mode="out-in">
          <Breadcrumbs
            :key="$route.name !== 'contact' ? 'contact' : 'index'"
            :voice="$route.name !== 'contact' ? contact : index"
            direction="prev"
            trans="default"
          />
        </transition>
      </aside>

      <aside class="footer__top">
        <Breadcrumbs
          :voice="top"
          direction="prev"
          trans="top"
        />
      </aside>
    </div>

    <div
      class="footer__wrapper"
      v-if="mobileFooter"
    >
      <div
        class="footer__line"
        data-anim="line"
      />

      <aside class="footer__contact">
        <Breadcrumbs
          :voice="$store.state.prev"
          direction="prev"
          trans="default"
        />
      </aside>

      <aside class="footer__top">
        <Breadcrumbs
          :voice="$store.state.next"
          direction="prev"
          trans="default"
        />
      </aside>
    </div>

  </footer>
</template>

<script>
import translate from '@/assets/i18n';

import Paragraph from '@/components/text/Paragraph.vue';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import Title from '@/components/text/Title.vue';

export default {
  name: 'Footer',

  components: {
    Breadcrumbs,
  },

  data() {
    return {
      contact: {
        id: this.$route.name,
        url: this.$store.state.lang === 'it' ? '/it/contatti' : '/en/contacts',
        label: translate('CONTATTI', this.$store.state.lang),
      },

      index: {
        id: this.$route.name,
        url: this.$store.state.lang === 'it' ? '/it' : '/en',
        label: 'Index',
      },

      top: {
        id: 'top',
        url: '#top',
        label: 'Top',
      }
    };
  },

  computed: {
    mobileFooter() {
      return window.innerWidth < 768 && (this.$route.name === 'project' || this.$route.name === 'person');
    },
  },

  methods: {
    enter(el, done) {
      setTimeout(() => {
        done();
      }, 1000);
    },

    leave(el, done) {
      setTimeout(() => {
        done();
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  padding: 100px 25px 0;

  grid-area: footer;

  display: flex;
  flex-flow: row wrap;
  align-items: center;

  @include mq(ipadP) {
    padding: 20vh 0 0 0;
  }

  .footer {
    &__wrapper {
      position: relative;
      width: 100%;
      padding: rem(40px) 0;

      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: baseline;

      @include mq(ipadP) {
        padding: rem(60px) 0;
      }
    }

    &__line {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 1px;

      background-color: $color-dark-light;

      @include mq(ds) {
        width: calc(100% + #{rem(100px)});
        left: rem(-100px);
      }
    }

    &__contact {
      position: relative;

      @include mq(ds) {
        left: rem(-100px);
      }
    }

    &__next {
      &__wrapper {
        position: absolute;
        right: rem(-50px);
        top: rem(-13px);
      }
      &__link {
        position: absolute;
        left: 0;
        h2 {
          color: $color-bg;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
